import { atom } from '@exodus/headless-ui';
import toAssetAtom from './to-asset.js';
import fromAmountAtom from './from-amount.js';
import toAmountAtom from './to-amount.js';
import prefillIdAtom from './prefill-id.js';
import { fromAssetNameAtom, fromAssetNameWithConfigAtom } from './from-asset-name.js';
const fromAssetAtom = atom((get, { selectors }) => {
    const availableAssets = get(selectors.availableAssets.all);
    const assets = Object.values(availableAssets);
    if (assets.length === 0)
        return undefined;
    const fromAssetName = get(fromAssetNameWithConfigAtom);
    const currentAsset = availableAssets[fromAssetName];
    const fallbackAsset = assets[0];
    return currentAsset || fallbackAsset;
}, (get, set, newValue) => {
    if (!newValue)
        return set(fromAssetNameAtom, undefined);
    const oldValue = get(fromAssetAtom);
    const toAsset = get(toAssetAtom);
    set(fromAssetNameAtom, newValue.name);
    set(fromAmountAtom, undefined);
    set(toAmountAtom, undefined);
    set(prefillIdAtom, null);
    if (toAsset.name === newValue.name) {
        set(toAssetAtom, oldValue);
    }
});
export default fromAssetAtom;
